<div [ngSwitch]="layout">

  <section *ngSwitchDefault>
    <div *ngIf="uploader" class="switch-default">
      <div
        class="ng2FileDrop"
        [ngClass]="{ 'has-file': hasBaseDropImageUpload }"
        ng2FileDrop
        [uploader]="uploader"
        (fileOver)="fileOverBase($event)"
      >
        <div *ngIf="!flagIsUploading">
          <i class="material-icons">file_upload</i>
          <em>{{ labelText }}</em>
          <span class="btn btn-outline-light">
            <span>{{ buttonLabel }}</span>
            <input
              type="file"
              id="imageUrl"
              ng2FileSelect
              [uploader]="uploader"
            />
          </span>
          <small class="max-filesize">{{ maxSizeText }}</small>
        </div>
        <div *ngIf="flagIsUploading">
          <small class="max-filesize">{{ imgUploadMessage }}</small>
        </div>
      </div>
      <div class="alert alert-danger" *ngIf="errorUpload">
        Problema ao enviar o arquivo. Erro: {{ imgUploadMessage }}
      </div>
  
      <div class="alert alert-danger" *ngIf="flagErrorMimeType">
        Formato do arquivo inválido. {{ imgUploadMessage }}
      </div>
      <div class="help-text" *ngIf="helpText">
        {{ helpText }}
      </div>
    </div>
  </section>

  <section  *ngSwitchCase="'generalFavIcon'">
    <div class="switch-general-fav-icon">
      <div
        class="ng2FileDrop"
        [ngClass]="{ 'has-file': hasBaseDropImageUpload }"
        ng2FileDrop
        [uploader]="uploader"
        (fileOver)="fileOverBase($event)"
      >
        <div *ngIf="!flagIsUploading" class="pt-3 pb-3">
          <div class="d-flex align-items-center justify-content-center">
            <i class="material-icons">file_upload</i>
            <em>{{ labelText }}</em>
          </div>
          <span class="btn btn-outline-light">
            <span>{{ buttonLabel }}</span>
            <input
              type="file"
              id="imageUrl"
              ng2FileSelect
              [uploader]="uploader"
            />
          </span>
          <small class="max-filesize">{{ maxSizeText }}</small>
        </div>
        <div *ngIf="flagIsUploading" class="div-max-filesize">
          <small class="max-filesize">{{ imgUploadMessage }}</small>
        </div>
      </div>
      <div class="alert alert-danger mt-2" *ngIf="errorUpload">
        Problema ao enviar o arquivo. Erro: {{ imgUploadMessage }}
      </div>
      <div class="alert alert-danger mt-2" *ngIf="flagErrorMimeType">
        Formato do arquivo inválido. {{ imgUploadMessage }}
      </div>
      <div class="help-text mt-2" *ngIf="helpText">
        {{ helpText }}
      </div>
    </div>
  </section>
</div>

